class GetAppointmentDayReq {
    constructor(){
        this.Id =undefined;
        this.IsConfirmed =undefined;
        this.IsSplit =false;
        this.IsFirstHalf =false;
        this.IsHalfDuration =false;
        this.PatientId =undefined;
        this.SessionId =undefined;
        this.AppointmentRequestId =undefined;
        this.AppHourId =undefined;
        this.AccountingSessionId =undefined;
        this.Priority =undefined;
        this.HourIds =undefined;
        
    }
}

export default GetAppointmentDayReq;